export const JIRA = 'jira';
export const JIRA_SERVICE_DESK = 'jsd';
// export const JIRA_SOFTWARE = "jsw";
export const CONFLUENCE = 'confluence';
export const HIPCHAT = 'hipchat';
export const BITBUCKET = 'bitbucket';
export const TRELLO = 'trello';
export const FECRU = 'fecru';
export const BAMBOO = 'bamboo';
export const CROWD = 'crowd';
export const COMPASS = 'compass';